module.exports = __webpack_public_path__ + "static/media/Scan 3.08090506.jpeg";